import { useQuery } from '@tanstack/react-query'
import { fetchJobberRequests, fetchTodayRequestsByCity } from '../api/requests'
import type { JobberRequestsQuery, JobberCityStatusBreakdown, JobberRequestsResult } from '../types'
import { jobberQueryKeys } from './queryKeys'

export function useJobberRequests(query: JobberRequestsQuery) {
  return useQuery<JobberRequestsResult>({
    queryKey: jobberQueryKeys.requests.list(query),
    queryFn: () => fetchJobberRequests(query),
  })
}

export function useTodayRequestsByCity(city: string) {
  return useQuery<JobberCityStatusBreakdown>({
    queryKey: jobberQueryKeys.requests.todayByCity(city),
    queryFn: () => fetchTodayRequestsByCity(city),
    enabled: !!city,
  })
}
